import { ApolloError } from "@apollo/client";
import { useMemo } from "react";

import { IRiskOption } from "src/core/constants/options";
import { Country, useCountriesWithRiskListQuery } from "src/core/gql/graphql";
import { mapCountriesToRiskOptions } from "src/core/mappers/country-risk.mapper";

export const useCountryWithRiskOptions = (): {
  countryWithRiskOptions: IRiskOption[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data: countryWithRiskList, loading, error } = useCountriesWithRiskListQuery();

  const countryWithRiskOptions: IRiskOption[] = useMemo(() => {
    if (!countryWithRiskList?.listElements) return [];

    const countries = countryWithRiskList.listElements.filter(
      (element): element is Country =>
        element.__typename === "Country" && Array.isArray(element.riskValues)
    );

    const options = mapCountriesToRiskOptions(countries);

    return options;
  }, [countryWithRiskList]);

  return { countryWithRiskOptions, loading, error };
};
